<div class="flex flex-row w-full justify-center mb-12">
  <h3 class="text-3xl">Financial Overview</h3>
</div>
<!--<div class="lg:hidden flex flex-row gap-10 justify-center mb-30">-->
<!--  <tandem-button [onClick]="setChart.bind(this, 'fp')" [disabled]="chartDisplayed === 'fp'">Financial Position</tandem-button>-->
<!--  <tandem-button [onClick]="setChart.bind(this, 'cf')" [disabled]="chartDisplayed === 'cf'">Cash Flow</tandem-button>-->
<!--  <tandem-button [onClick]="setChart.bind(this, 'sp')" [disabled]="chartDisplayed === 'sp'">Spending Plan</tandem-button>-->
<!--</div>-->

<div class="w-full flex flex-col gap-20 md:gap-10 lg:flex-row justify-around">
  <div class="w-full lg:w-1/3 h-auto flex flex-col">
    <div class="flex flex-row gap-10 w-full justify-center">
      <h4 class="text-2xl font-bold">{{getTrackingToolNameSingular('fp')}}</h4>
    </div>
    <tandem-financial-position-graph *ngIf="financialPosition" [financialPosition]="financialPosition" [omitLabelLines]="true" [showSubtitle]="true" [showLegend]="false" [isSampleData]="showingDefaultFP"></tandem-financial-position-graph>
  </div>
  <div class="w-full lg:w-1/3 h-auto flex flex-col">
    <div class="flex flex-row gap-10 w-full justify-center">
      <h4 class="text-2xl font-bold">{{getTrackingToolNameSingular('cf')}}</h4>
    </div>
    <tandem-cash-flow-graph  *ngIf="cashFlow" [cashFlow]="cashFlow" [omitLabelLines]="true" [showSubtitle]="true" [showLegend]="false" [isSampleData]="showingDefaultCF"></tandem-cash-flow-graph>
  </div>
  <div class="w-full lg:w-1/3 h-auto flex flex-col">
    <div class="flex flex-row gap-10 w-full justify-center">
      <h4 class="text-2xl font-bold">{{getTrackingToolNameSingular('sp')}}</h4>
    </div>
    <tandem-spending-plan-graph  *ngIf="spendingPlan" [spendingPlan]="spendingPlan" [omitLabelLines]="true" [showSubtitle]="true" [showLegend]="false" [isSampleData]="showingDefaultSP"></tandem-spending-plan-graph>
  </div>
<!--  <tandem-loading-container [isLoaded]="fpLoaded">-->
<!--    <div *ngIf="financialPosition && (chartDisplayed === 'fp' || chartDisplayed === 'all')" class="w-1/3 h-400 border border-red">-->
<!--      <tandem-financial-position-graph [financialPosition]="financialPosition" [omitLegend]="true" class="h-400"></tandem-financial-position-graph>-->
<!--    </div>-->
<!--    <div *ngIf="!financialPosition && (chartDisplayed === 'fp' || chartDisplayed === 'all')" class="w-300 h-full text-center flex flex-col justify-center items-center">-->
<!--      <h4>No Available Financial Position!</h4>-->
<!--    </div>-->
<!--  </tandem-loading-container>-->
<!--  <tandem-loading-container [isLoaded]="cfLoaded">-->
<!--    <ng-container *ngIf="cashFlow && (chartDisplayed === 'cf' || chartDisplayed === 'all')">-->
<!--      <tandem-cash-flow-graph [cashFlow]="cashFlow" [omitLegend]="true"></tandem-cash-flow-graph>-->
<!--    </ng-container>-->
<!--    <div *ngIf="!cashFlow && (chartDisplayed === 'cf' || chartDisplayed === 'all')" class="w-300 h-full text-center flex flex-col justify-center items-center">-->
<!--      <h4>No Available Cash Flow!</h4>-->
<!--    </div>-->
<!--  </tandem-loading-container>-->
<!--  <tandem-loading-container [isLoaded]="spLoaded">-->
<!--    <ng-container *ngIf="spendingPlan && (chartDisplayed === 'sp' || chartDisplayed === 'all')">-->
<!--      <tandem-spending-plan-graph [spendingPlan]="spendingPlan" [omitLegend]="true"></tandem-spending-plan-graph>-->
<!--    </ng-container>-->
<!--    <div *ngIf="!spendingPlan && (chartDisplayed === 'sp' || chartDisplayed === 'all')" class="w-300 h-full text-center flex flex-col justify-center items-center">-->
<!--      <h4>No Available Spending Plan!</h4>-->
<!--    </div>-->
<!--  </tandem-loading-container>-->
</div>
